// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5849":"f889e5b6","8452":"a092b935"}[chunkId] + ".chunk.css";
};